import React, { PureComponent } from 'react';
import {BasicCard, SimpleText} from './AnswerBalloon'
import Flicking from "@egjs/react-flicking"
import $ from 'jquery'



class CarouselBalloon extends PureComponent {
    constructor(props) {
        super(props);
        this.flickingRef = React.createRef(); // Instance를 클래스 필드로 선언
    }

    componentDidMount() {
        /* @egjs/react-flicking */   
        if (this.carousel !== undefined) {
            //const defaultHeight = "150"
            let panelCount = this.carousel.getPanelCount();
            let maxHeight = 0;
            for (let idx = 0; idx < panelCount; idx++) {
                if (maxHeight < $(this.carousel.getPanel(idx).getElement().firstChild).height()) {
                    maxHeight = $(this.carousel.getPanel(idx).getElement().firstChild).height()
                }
            }
            if (maxHeight > 0) {
                for (let idx = 0; idx < panelCount; idx++) {
                    this.carousel.getPanel(idx).getElement().firstChild.style.height = maxHeight+"px";
                }
            }
        }
    }
	goToPrevSlide = () => {
        if (this.flickingRef.current) {
            this.flickingRef.current.prev().catch(() => {});
        }
    };

    goToNextSlide = () => {
        if (this.flickingRef.current) {
            this.flickingRef.current.next().catch(() => {});
        }
    };
    render() {
        const itemType = this.props.data.type;
        const carouselItems = this.props.data.items.map (
            (item, i) => (
                itemType === "simpleText" 
                ?  <SimpleText data={ item } key = { i } fromCarousel={true} fromApp={this.props.fromApp}/> 
                : itemType === "basicCard" && <BasicCard data={ item } key = { i } fromCarousel={true} fromApp={this.props.fromApp}/>
            )
        )
        
        return (
            this.props.data.items.length > 1 ?
            <div className="menual_area">
				{
                   this.props.data.items.length > 2 ? <button className="nav-button left" onClick={this.goToPrevSlide}>◀</button> : <></>
                }
				<Flicking 
					ref={this.flickingRef} 
					key={Math.random().toString(36).substr(2,11)}
					tag = "div"
					viewportTag = "div"
					cameraTag = "div"
					classPrefix = "eg-flick"
					deceleration = {0.0075}
					horizontal = {true}
					circular = {false}
					infinite = {false}
					infiniteThreshold = {0}
					lastIndex = {Infinity}
					threshold = {20}
					duration = {500}
					panelEffect = {x => 1 - Math.pow(1 - x, 3)}
					defaultIndex = {0}
					inputType = {["touch", "mouse"]}
					thresholdAngle = {45}
					bounce = {['10', '10']}
					autoResize = {true}
					adaptive = {false}
					bound = {false}
					overflow = {true}
					hanger = {0}
					anchor = {0}
					gap = {2}
					zIndex = {8}
                    moveType = {{type: "snap", count: 1}}
					collectStatistics = {false}>
					{ carouselItems }
				</Flicking>
                {
                   this.props.data.items.length > 2 ? <button className="nav-button right" onClick={this.goToNextSlide}>▶</button> : <></>
                }
				
            </div>
            : this.props.data.type === "simpleText" 
                ?  <SimpleText data={ this.props.data.items[0] } fromCarousel={false} fromApp={this.props.fromApp}/> 
                : this.props.data.type === "basicCard" 
                    && <BasicCard data={ this.props.data.items[0].itemType } fromCarousel={false} fromApp={this.props.fromApp}/>
        )
    }
};

export default CarouselBalloon;